import {
  IconDashboard,
  IconUser,
  IconUsers,
  IconBuilding,
  IconShieldCheck,
  IconChartLine,
  IconBox,
  IconFileText,
  IconSettings,
  IconMail,
  IconDatabase,
  IconBrandChrome,
  IconBinaryTree2,
  IconWallet,
  IconClipboardList,
  IconBriefcase,
  IconMap,
  IconActivity,
  IconBuildingCommunity,
  IconUserCircle,
  IconPuzzle,
  IconCreditCard
} from '@tabler/icons-react';

const owner = {
  id: 'owner',
  title: 'Owner',
  type: 'group' as const,
  children: [
    {
      id: 'dashboard',
      title: 'Dashboard',
      type: 'item' as const,
      url: '/dashboard',
      icon: IconDashboard,
      breadcrumbs: false
    },
    {
      id: 'analytics',
      title: 'Analytics',
      type: 'item' as const,
      url: '/analytics',
      icon: IconChartLine,
      breadcrumbs: false
    },
    {
      id: 'management',
      title: 'Management',
      type: 'collapse' as const,
      icon: IconBuilding,
      children: [
        {
          id: 'users',
          title: 'Users',
          type: 'item' as const,
          url: '/users',
          icon: IconUser,
          breadcrumbs: false
        },
        {
          id: 'distributors',
          title: 'Channel Partner',
          type: 'item' as const,
          url: '/distributors',
          icon: IconBrandChrome,
          breadcrumbs: false
        },
        {
          id: 'resellers',
          title: 'Resellers',
          type: 'item' as const,
          url: '/resellers',
          icon: IconBinaryTree2,
          breadcrumbs: false
        },
        {
          id: 'customers',
          title: 'Customers',
          type: 'item' as const,
          url: '/customers',
          icon: IconUsers,
          breadcrumbs: false
        }
      ]
    },
    {
      id: 'products',
      title: 'Products & Plans',
      type: 'collapse' as const,
      icon: IconBox,
      children: [
        {
          id: 'db-pools',
          title: 'DB Pools',
          type: 'item',
          url: '/db-pools',
          icon: IconActivity,
          breadcrumbs: false
        },
        {
          id: 'products-list',
          title: 'Products',
          type: 'item' as const,
          url: '/products',
          icon: IconBox,
          breadcrumbs: false
        },
        {
          id: 'modules',
          title: 'Modules',
          type: 'item' as const,
          url: '/modules',
          icon: IconPuzzle,
          breadcrumbs: false
        },
        {
          id: 'plans',
          title: 'Plans',
          type: 'item' as const,
          url: '/plans',
          icon: IconClipboardList,
          breadcrumbs: false
        }
      ]
    },
    {
      id: 'subscriptions',
      title: 'Subscriptions',
      type: 'item' as const,
      url: '/subscriptions',
      icon: IconFileText,
      breadcrumbs: false
    },
    {
      id: 'orders',
      title: 'Orders',
      type: 'item' as const,
      url: '/orders',
      icon: IconWallet,
      breadcrumbs: false
    },
    {
      id: 'campaigns',
      title: 'Campaigns',
      type: 'item',
      url: '/campaigns',
      icon: IconMail,
      breadcrumbs: false
    },
    {
      id: 'credits',
      title: 'Credits',
      type: 'item' as const,
      url: '/credits',
      icon: IconCreditCard,
      breadcrumbs: false
    },
    {
      id: 'profile',
      title: 'Profile',
      type: 'item' as const,
      url: '/profile',
      icon: IconUser,
      breadcrumbs: false
    },
    {
      id: 'business',
      title: 'Business Intelligence',
      type: 'collapse',
      icon: IconBriefcase,
      children: [
        {
          id: 'consultants',
          title: 'Consultants',
          type: 'item',
          url: '/consultants',
          icon: IconUserCircle,
          breadcrumbs: false
        },
        {
          id: 'associations',
          title: 'Associations',
          type: 'item',
          url: '/associations',
          icon: IconBuildingCommunity,
          breadcrumbs: false
        },
        {
          id: 'industries',
          title: 'Industries',
          type: 'item',
          url: '/industries',
          icon: IconBriefcase,
          breadcrumbs: false
        },
        {
          id: 'prospects',
          title: 'Prospects',
          type: 'item',
          url: '/prospects',
          icon: IconMap,
          breadcrumbs: false
        }
      ]
    },
    {
      id: 'system',
      title: 'System',
      type: 'collapse',
      icon: IconDatabase,
      children: [
        {
          id: 'activity-logs',
          title: 'Activity Logs',
          type: 'item',
          url: '/activity-logs',
          icon: IconActivity,
          breadcrumbs: false
        },
        {
          id: 'system-health',
          title: 'System Health',
          type: 'item',
          url: '/system/health',
          icon: IconShieldCheck,
          breadcrumbs: false
        },
        {
          id: 'settings',
          title: 'Settings',
          type: 'item',
          url: '/settings',
          icon: IconSettings,
          breadcrumbs: false
        }
      ]
    }
  ]
};

export default owner;

